module.exports = __webpack_public_path__ + "az.no1.3b91ad7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/az.no1.jpg
// module id = qS0X
// module chunks = 0